import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom'
import styled from 'styled-components';
import qs from 'qs'
import CommunityPhotoUploadDetail from './CommunityPhotoUploadDetail'; 
import CommentBar from '../../../fixbar/CommentBar';
import dotbtn from '../../../../images/dotbtn.png';
import serverController from '../../../../server/serverController';
import server from 'server/serverController2';
import appInfoContainer from '../../../../auth/appInfoContainer';
import { useSelector } from 'react-redux';
import BottomModal from 'components/presenters/modal/BottomModal';
import DotButton from 'components/presenters/button/DotButton';
import { removeItem } from 'utils/utils';
import CommentList from 'components/containers/comment/list/CommentList'; 
import CenterModal from 'components/presenters/modal/CenterModal';
export default function Cummunity_comment({ match }) {
	const userInfo = useSelector((state) => {
		return state.userInfo;
	}); 
	const scrollRef = useRef(null);
	const inputRef = useRef(null); 
	const history = useHistory();
	const [modalOption, setModalOption] = useState('');
	const [modalShow, setModalShow] = useState(false);  
	const [replycontent, setReplycontent] = useState('');
	const [currentPostIndex, setCurrentPostIndex] = useState(0);
	const [communityList, setCommunityList] = useState([]);
	//const [comments, setComments] = useState([]);
	const [insertedItemList, setInsertedItemList] = useState([]);
	const [insertedItemIndexes, setInsertedItemIndexes] = useState([]);
	const [chatbar, setChatbar] = useState(false);
	const [currentPostNo, setCurrentPostNo] = useState('');

	const [loadNextComment, setLoadNextComment] = useState(false);

	//Center Modal State
	const [initCenterModal, setInitCenterModal] = useState(false);
	const [centerModalVisible, setCenterModalVisible] = useState(false);
	const [centerModalDataList, setCenterModalDataList] = useState({});
	const [onCenterModalComplete, setOnCenterModalComplete] = useState(null);
	const [onCenterModalCancel, setOnCenterModalCancel] = useState(null);

	//ModalState
	const [visible, setVisible] = useState(false);
	const [dataList, setDataList] = useState([]);
	//LottieState
	const [isLikeAnimation, setIsLikeAnimation] = useState(false)

	//Init Center Modal State
	useEffect(()=>{
		if(initCenterModal === true)
		{
			setCenterModalVisible(false);
			setCenterModalDataList({})
			setOnCenterModalComplete(null);
			setOnCenterModalCancel(null);
			setInitCenterModal(false);
		}
	}, [initCenterModal])

	const openModal = (callBack) => {
		if (callBack) { 
			setModalShow(true);
		}
	};

	
	// 포스트 상세 데이터 불러오기
	const infoCallBack = (res) => {
		if (res.success !== 1) {
			const errData = res?.error?.res_data;
			if(errData['detail_code'] === 'NOT_A_CAMPAIGN_MEMBER')
			{
				setCenterModalVisible(true);
				setCenterModalDataList({description:"챌린지에 가입하시면 볼 수 있어요"});
				setOnCenterModalComplete(()=>()=>{ 
					history.replace(`/campaign/${match.params['id']}`);
					setInitCenterModal(true);
				})
			}
			else {
				setCenterModalVisible(true);
				setCenterModalDataList({description:"예기치 못한 문제가 발생하였습니다.\n 나중에 다시 시도해주세요"});
				setOnCenterModalComplete(()=>()=>{
					history.replace(`/campaigns/${match.params['id']}`);
					setInitCenterModal(true);
				})
			}
			/*


											*/
			return;
		}
		setCommunityList(res.data.posts);
	};
	//페이지가 렌더링이 되었을 때 한번 호출
	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		serverController.getServerData(
			`campaigns/posts/${match.params.no}`,
			infoCallBack,
			);
	}, []);

	// 포스트 삭제
	const postdelcallBack = (res) => {
		if (res.success === 1) {
			window.location.reload();
			//serverController.getServerData("auth",test);
		} else {
			alert('실패');
		}
	}; 

	// 댓글쓰기
	// const callBack = (res) => {
	//   isclick = false;
	//   if (res.success === 1) {
	//     window.location.reload();
	//   } else {
	//     alert('실패');
	//   }
	// };

	/*--click block--*/
	var isclick = false; 

	// 댓글 삭제
	const [delnumber, setDelnumber] = useState(null);
	const delcallBack = (res) => {
		if (res.success === 1) {
			window.location.reload();
			//serverController.getServerData("auth",test);
		} else {
			alert('실패');
		}
	}; 

	// 좋아요 누르기
	const likecallBack = (res) => {
		isclick = false;
		if (res.success === 1) {
			setIsLikeAnimation(true);
			setCurrentPostNo(res.data.inserted_item.post_no)
			let list = [...communityList];
			list.map((value) => {
				if (value.no === res.data.inserted_item.post_no) {
					value.total_like = parseInt(value.total_like) + 1;
					value.liked_post = true;
				}
			});
			setCommunityList(list);
			setTimeout(() => setIsLikeAnimation(false), 1500);
		} else {
			alert('실패');
		}
	};
	const likedataSubmit = (indexOptional) => {
		if (isclick) return;
		isclick = true;

		var postIndex = indexOptional ? indexOptional : currentPostIndex;
		let data = {};
		serverController.generalPostFetchController(
			`campaigns/posts/${postIndex}/like`,
			JSON.stringify(data),
			likecallBack,
			);
	};

	// 좋아요 삭제
	const likedelcallBack = (res) => {
		if (res.success === 1) {
			let list = [...communityList];
			list.map((value) => {
				if (value.no === res.data.deleted_item[0].post_no) {
					value.total_like = parseInt(value.total_like) - 1;
					value.liked_post = false;
				}
			});
			setCommunityList(list);
		} else {
			alert('실패');
		}
	};
	const likedeldataSubmit = (indexOptional) => {
		var postIndex = indexOptional ? indexOptional : currentPostIndex;
		let data = {};
		serverController.updateFileDeleteFetchController(
			`campaigns/posts/${postIndex}/like`,
			JSON.stringify(data),
			likedelcallBack,
			);
	};

	// const submitCommentRequest = async () => {
	//   try {
	//     if(replycontent === '' || replycontent.trim() === '') {
	//       inputRef.current.value = '';
	//       return;
	//     }
	//     const body = {
	//       content: replycontent  
	//     }
	//     const submitResult = await server.postRequestData(`campaigns/posts/${match.params.no}/comments`, body);
	//     if(submitResult['success'] === 0) {
	//       return;
	//     }
	//     scrollRef.current.scrollTop = 0;
	//     const {inserted_item} = submitResult['data'];
	//     const communityDetailItem = communityList[0];
	
	//     if(inserted_item['post_no'] === communityDetailItem['no']) {
	//       communityDetailItem.total_comment = parseInt(communityDetailItem.total_comment) + 1;
	//       setCommunityList([communityDetailItem]);
	//     }
	//     inserted_item['profile_img'] = userInfo['profile_img'];
	//     inserted_item['nickname'] = userInfo['name'];
	//     setInsertedItemIndexes([inserted_item.no, ...insertedItemIndexes]);
	//     setInsertedItemList([inserted_item, ...insertedItemList]);
	//     setReplycontent('');
	//     setChatbar(false);
	//   } catch (error) {
	//     if(process.env.NODE_ENV === 'development') {
	//       console.log(error);
	//     } 
	//   }
	// }

	const handleScroll = (e) => {
		const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
		if(bottom) {
			setLoadNextComment(true);
		}
	}

	return (
		<CummunityCommentInner onScroll={handleScroll} ref={scrollRef}> 
		{
			communityList.map((value, index) => {
				return (
					<CommunityPhotoUploadDetail
						key={`comment-post-no-${value['no']}`}
						path={true}
						borderwidth={'calc(100vw*(1/375)) 0'}
						borderline={'solid #eaeaea'}
						margintop={'calc(100vw*(16.5/375))'}
						openModal={openModal}
						item={value}
						likedataSubmit={likedataSubmit}
						likedeldataSubmit={likedeldataSubmit}
						userInfo={userInfo}
						setCurrentPostIndex={setCurrentPostIndex}
						setModalShow={setModalShow}
						setModalOption={setModalOption}
						currentPostNo={currentPostNo}
						isLikeAnimation={isLikeAnimation}
					/>
				);
			})
		}
		<CummunityCommentArea>  
		<CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onCenterModalCancel} onComplete={onCenterModalComplete}/>
			<CommentList 
				scrollRef={scrollRef}
				type={`campaign_post`} 
				listType={'comment_list'}
				targetNo={match.params.no}
				loadNext={loadNextComment}
				setLoadNext={setLoadNextComment}
			/>  
		</CummunityCommentArea>
		<BottomModal visible={visible} setVisible={setVisible} dataList={dataList}/>
		</CummunityCommentInner>
	);
}

function CommentUserList({
	value,
	userInfo,
	handleModalState,
	backgroundColor
}) {
	const today = new Date();
	const timeValue = new Date(value.create_date);
	const betweenTimeS = Math.floor(
		(today.getTime() - timeValue.getTime()) / 1000,
		);
	const betweenTimeM = Math.floor(
		(today.getTime() - timeValue.getTime()) / 1000 / 60,
		);
	const betweenTimeHour = Math.floor(betweenTimeM / 60);
	const betweenTimeDay = Math.floor(betweenTimeM / 60 / 24);

	const CommentTime = () => {
		if(betweenTimeS < 0) {
			return `0s`;
		}
		if (betweenTimeS < 60) {
			return `${betweenTimeS}s`;
		} else if (betweenTimeM < 60) {
			return `${betweenTimeM}m`;
		} else if (betweenTimeHour < 24) {
			return `${betweenTimeHour}h`;
		} else if (betweenTimeDay < 365) {
			return `${betweenTimeDay}d`;
		} else {
			return `${Math.floor(betweenTimeDay / 365)}y`;
		}
	};
	return (
		<div>
		<CummunityCommentText style={{background: backgroundColor}} >
		<UserImg>
		<Images
		src={
			appInfoContainer.imagePath +
			'/user_profile_img/' +
			value.profile_img
		}
		alt={'user profile'}
		/>
		</UserImg>
		<CummunityCommentTextList>
		<CommList>
		<Name>{value.nickname}</Name>
		<CommentTxt>{value.content}</CommentTxt>
		{value.user_no === userInfo.id ? (
			<DotButtonarea>
			<DotButton onClick={(e) => handleModalState(e, value)} style={{marginLeft: 'calc(100vw * (4 / 375))'}}>
			<img src={dotbtn} alt={'option button'} />
			</DotButton>
			</DotButtonarea>
			) : null}
		</CommList>
		<CommList>
		<CommTime>{CommentTime()}</CommTime>
		</CommList>
		</CummunityCommentTextList>
		</CummunityCommentText>
		</div>
		);
}

const Images = styled.img`
width: 100%;
height: 100%;
object-fit: cover;
`;
const CummunityCommentInner = styled.div`
	//padding: 0 0 calc(100vw * (69 / 375)) 0;
	overflow-y: scroll;
	height: 100%;
	`;
	const CummunityCommentArea = styled.div`
		padding:  calc(100vw * (16 / 375)) 0 0 calc(100vw * (17 / 375));
	`;
	const CummunityCommentText = styled.div`
	display: flex;
	align-items: center;
	padding: 0.5rem 1rem;
	`;
	const CummunityCommentTextList = styled.ul`
	position: relative;
	margin-left: calc(100vw * (6 / 375));
	margin-top: calc(100vw * (11 / 375));
	margin-bottom: calc(100vw * (11 / 375));
	width: calc(100vw * (300 / 375));
	`;
	const UserImg = styled.div`
	width: calc(100vw * (28 / 375));
	height: calc(100vw * (28 / 375));
	border-radius: 50%;
	overflow: hidden;
	border: solid calc(100vw * (1 / 375)) #c6c6c6;
	margin-bottom: calc(100vw * (5 / 375));
	`;
	const CommentTxt = styled.span`
	white-space: pre-wrap;
	font-size: calc(100vw * (14 / 375));
	color: #1d1d1d;
	word-break:break-all;
	`;
	const Name = styled.span`
	font-size: calc(100vw * (14 / 375));
	color: #1d1d1d;
	font-weight: 500;
	margin-right: calc(100vw * (5 / 375));
	`;
	const CommTime = styled.span`
	font-size: calc(100vw * (11 / 375));
	line-height: 1.55;
	color: #989898;
	`;

	const DotButtonarea = styled.span`
	position: absolute;
	top: 0;
	right: 0;
	width: calc(100vw * (5 / 375));
	padding: clac(100vw * (8.5 / 375));
	`;

	const CommList = styled.li`
	position: relative;
	`;

	const Spacer = styled.div`
	height: calc(100vw * (150/375));
	`;
